import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import notifyAnalytics from '../notify-analytics';
import styles from './DesktopMenuItem.scss';

const TouchMenuItem = ({ label, url, active, onSelect, onClose, children }) => {
  const handleOnClick = () => (active ? onClose() : onSelect());

  const childrenWithProps = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { onClose });
    }
    return child;
  });

  const cn = classNames(styles.desktopMenuItem, {
    [styles.desktopMenuItem__active]: active,
  });

  return (
    <li className={cn}>
      {url && !children && (
        <a
          className={styles.desktopMenuItemLink}
          href={url}
          onClick={() => notifyAnalytics(label)}
        >
          {label}
        </a>
      )}
      {children && (
        <>
          <button
            className={styles.touchMenuItemButton}
            onClick={handleOnClick}
          >
            {label}
          </button>
          {active && childrenWithProps}
        </>
      )}
    </li>
  );
};

TouchMenuItem.defaultProps = {
  url: '',
  children: undefined,
};

TouchMenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  url: PropTypes.string,
  children: PropTypes.node,
};

export default TouchMenuItem;
